<sc-splash-screen></sc-splash-screen>
<router-outlet></router-outlet>
